export default __webpack_public_path__ + "static/media/purpleTicket@3x.4088eb09.png";